<template>
    <main class="container" v-if="renderPage">
        <div class="row justify-content-center">
            <div class="col-12 espera text-center">
                <h1>{{nome}}, aguarde...</h1>
                <div class="svg" >
                    <div class="relogio"></div>
                </div>
                <h2>Estamos analisando a sua solicitação</h2>
                <p>Em breve você saberá se pode tomar um empréstimo através da IOUU.</p>
            </div>
        </div>
    </main>
</template>

<script>
    import * as mutationTypes from "@/store/mutation-types.js";
    import ApiClient from "@/utils/api-client";

    export default {
        data() {
            return {
                solicitacao   : null,
                renderPage    : false,
            }
        },
        computed: {
            nome: function(){
                this.solicitacao.Nome = this.solicitacao.Nome.trim();
                let name = this.solicitacao.Nome.split(" ");
                let firstName = name[0];

                return firstName;
            },
        },
        beforeCreate() {
            let idSolicitacao = this.$route.query.id;

            this.$store.commit(mutationTypes.START_LOADING);
            ApiClient.getLoanRequest(idSolicitacao)
            .then(response => {
                this.solicitacao = response;
                this.renderPage = true;
                this.$store.commit(mutationTypes.STOP_LOADING)
            })
            .catch(() => this.$store.commit(mutationTypes.STOP_LOADING));
        }

    }
</script>

<style lang="scss" scoped>
    @import "../assets/styles/iouu/variables";
    @import "../assets/styles/iouu/mixins";

    h1 {
	    padding-bottom: 40px;
        @include font-size(35px);

        &::after {
	        display: none;
        }

        @include xs {
            padding-top: 100px;
        }
    }
    h2 {
        
        @include font-size(40px);
        line-height: 55px;
        font-weight: 200;

        @include xs {
            @include font-size(30px);
            @include line-height(30px);
            letter-spacing: 0px;
            font-weight: 300;
        }

        &::after {
            content: '';
            display: block;
            width: 150px;
            height: 5px;
            margin-top: 40px;
            margin-left: auto;
            margin-right: auto;
            margin-bottom: 40px;
            background: #41d3bd
        }
    }

    .svg {
        margin-bottom: 30px;
    }

    p {
        font-size: 18px;
        color: #000;
    }
</style>


// WEBPACK FOOTER //
// src/views/SolicitacaoAnalise.vue